import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextBox from '../../Basic/TextBox';
// import TextArea from '../../Basic/TextArea';
import PhoneBox from '../../Enhanced/PhoneBox';
import FortisButton from '../../Basic/FortisButton';
import EmailBox from '../../Enhanced/EmailBox';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import LinkButton from '../../Basic/LinkButton';
import AddressToString from '../AddressToString';
import { selectedAddress } from '../../../selectors/ServiceAddress';
import util from '../../../lib/util';
import { nextStepClicked } from '../../../actions';
import DatePicker from '../../Enhanced/DatePicker';
import * as consts from '../../../constants';

class OffRamp extends React.Component {
  onNextClick = () => {
    const p = this.props;
    const lookup = window.osa.lookup.serviceAddress;
    const validators = [
      ['OfframpName', p => p.name != null,  p.offramp.isEmailToPlanner? "Customer / company name" : lookup.name],
      ['RequiredByDate', p => (p.requiredBy), 'Preferred service date'],
      ['OfframpPhone', p => p.phone, lookup.phoneNumber],
      ['OfframpPhone', p => !p.phone || util.isPhoneValid(p.phone), '#Phone number is invalid'],
      ['OfframpEmail', p => p.email, 'Email address'],   
      ['OfframpEmail', p => !p.email || util.isEmailValid(p.email), '#Email address is invalid'],
    ];

    if (util.validate(validators, p, p.formError)) {

      let model = {
        Name: p.name,
        Phone: p.phone,
        PhoneExt: p.phoneExt,
        Email: p.email,
        ContactName: p.contactName,
        Notes: p.notes,
        Address: p.selectedAddress,
        RequiredBy: p.requiredBy,
        ProductType: p.productName === consts.NEW_GAS_LINE_NAME ? 0 :1,
        BuildingType : p.productName === consts.NEW_GAS_LINE_NAME ? util.getNamebyId(window.osa.lookup.serviceAddress.buildingType.items,p.buildingType) : '',
        IsSingleMeter : p.isSingleMeter,
        IsSingleMeterLocation : p.isSingleMeterLocation,
        IsNewBuilding : p.isNewBuilding,
        MeterLocation :  p.meterLocation,
        SquareFootage:  p.squareFootage,
        GasAppliances:  p.gasAppliances,
        HeatingSystem:  p.heatingSystem,
        AgeOfProperty:  p.ageOfProperty,
        OtherInfo: p.otherInfo
      };

      p.dispatch({ type: 'SUBMIT_OFFRAMP', model });
    }
  }
  goToNextStep = () => {
    const p = this.props;
    if (p.premiseNumber)
      p.dispatch({ type: 'READ_PREMISE', premiseNumber: p.premiseNumber });

    this.props.onNextStepClicked(1);
  }
  render() {
    const p = this.props;
    const lookup = window.osa.lookup.serviceAddress;
    const days = p.offramp && p.offramp.daysInMessage;
    const isOffRampPostponed = p.offramp && p.offramp.isOffRampPostponed;
    const isEmailToPlanner = p.offramp && p.offramp.isEmailToPlanner;
    const l =  window.osa && window.osa.lookup;
    const contactUsPhoneText = l.common && l.common.contactUsPhoneText;
    const message = lookup.offRampInfo + days + ' or you can ' + contactUsPhoneText;
    const message1 = '1. Complete the contact form below and we’ll call you within ' + days + ' or you can ' + contactUsPhoneText;
    const message2 = '2. Continue through the steps below and we’ll contact you to gather more information and schedule your request.';
    return (
      <div>
        <hr className="soften" />
        <div className="col-sm-12 offramp-page" >

          <h3 className="text-available"><AddressToString message={lookup.offRampConfirm} {...p.selectedAddress} /></h3>
          {
            isOffRampPostponed ?
              <p>
                We need more information to process your request. You have two options:
                  <div dangerouslySetInnerHTML={{ __html: message1 }} />
                OR
                 <div dangerouslySetInnerHTML={{ __html: message2 }} />
              </p>

              :
              <p> 
                { p.productName === consts.NEW_GAS_LINE_NAME ? "We need more information to determine if natural gas is available at your location. We’d like to speak with you to gather more details." : null }
                <div dangerouslySetInnerHTML={{ __html: message }} /> 
              </p>
          }
          <div className="row">
            <div className="col-sm-4">
              <TextBox title={ isEmailToPlanner ? "Customer / company name" : lookup.name } name="OfframpName" required />
            </div>
          </div>
          <br/>
          { isEmailToPlanner ?
          <div className="row">
            <div className="col-sm-4">
              <TextBox title="Contact Name (if different from above)" name="ContactName"  />
            </div>
             <br/>
          </div>
           : null
          }
          <div className="row">
            <div className="col-sm-4">
              <DatePicker id="RequiredByDate" name="RequiredByDate" required title="Preferred service date" pattern={consts.REGEX_DATE} isOffRamp={true} readOnly={true} />
            </div>
          </div>
          <br/>
          <div className="row">
            <div className="col-sm-4"><PhoneBox id="OfframpPhone" name="OfframpPhone" title={lookup.phoneNumber} required ext="1" /> </div>
          </div>
          <br/>
          <div className="row">
            <div className="col-sm-4">
                 <EmailBox id="OfframpEmail" name="OfframpEmail" title="Email address" required  errorMsg="Email address is required" maxLength={241} />   
             </div>
          </div>
          <br/>
           {/* {p.productName === consts.NEW_GAS_LINE_NAME 
           ?
           <div>
            <div className="row">
              <div className="col-sm-4">
                   <b>Please provide the following:</b>
                <TextBox title="Preferred meter location" name="OfframpMeterLocation"  />
              </div>             
            </div>
             <br/>
               <div className="row">
              <div className="col-sm-4">
                <TextBox title="Square footage of the property" name="OfframpSquareFootage"  />
              </div>      
            </div>
             <br/>
              <div className="row">
              <div className="col-sm-4">
                <TextBox title="Gas appliances to be used" name="OfframpGasAppliances"  />
              </div>             
            </div>
             <br/>
             <div className="row">
              <div className="col-sm-4">
                <TextBox title="Current heating system" name="OfframpHeatingSystem"  />
              </div>           
            </div>
             <br/>
            <div className="row">
              <div className="col-sm-4">
                <TextBox title="Age of property" name="OfframpAgeOfProperty"  />
              </div>              
            </div>
               <br/>
            <div className="row">
              <div className="col-sm-4">
                
                 <TextArea title="Other information" name="OfframpOtherInfo"  />
              </div>            
            </div>
              <br/>
          </div>
          :
            <div className="row">
              <div className="col-sm-4">
                <TextArea title="Additional notes" subTitle="(e.g. the best time to reach you)" name="OfframpNotes" />
              </div>
            </div>
           } */}
          <br />

          {isOffRampPostponed ?
            <div>
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <FortisButton text="Submit contact form" onClick={this.onNextClick} />
                  </div>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-md-2 text-left">
                  <b> Continue to next steps</b>
                </div>
                <div className="col-md-10 text-left">
                  <div className="form-group">
                    <ButtonToolbar  style={{display: "inline-flex"}}>
                      <FortisButton text="Next step" onClick={this.goToNextStep} />
                      <LinkButton text="&nbsp;Cancel" onClick={p.onCancelClick} />
                    </ButtonToolbar>
                  </div>
                </div>
              </div>
            </div>
            :
            <div>
              <p>{lookup.offRampSubmit}</p>
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <ButtonToolbar style={{display: "inline-flex"}}>
                      <FortisButton text="Submit contact form" onClick={this.onNextClick} />
                      <LinkButton text="&nbsp;Cancel" onClick={p.onCancelClick} />
                    </ButtonToolbar>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

    );
  }
}

OffRamp.propTypes = {
  offramp: PropTypes.object,
  parcel: PropTypes.object,
  name: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string,
  requiredBy: PropTypes.string,
  phoneExt: PropTypes.string,
  notes: PropTypes.string,
  selectedAddress: PropTypes.object,
  form: PropTypes.object,
  premiseNumber: PropTypes.string,
  productName: PropTypes.string,
  buildingType :  PropTypes.string,
  isSingleMeter : PropTypes.bool,
  isSingleMeterLocation: PropTypes.bool,
  isNewBuilding: PropTypes.bool,
  meterLocation: PropTypes.string,
  squareFootage: PropTypes.string,
  gasAppliances: PropTypes.string,
  heatingSystem: PropTypes.string,
  ageOfProperty: PropTypes.string,
  otherInfo: PropTypes.string
};

function mapStateToProps(state) {
  return {
    form: state.form,
    name: state.form.OfframpName,
    contactName : state.form.ContactName,
    phone: state.form.OfframpPhone,    
    phoneExt: state.form.OfframpPhone_ext,
    email: state.form.OfframpEmail,
    notes: state.form.OfframpNotes,
    requiredBy: state.form.RequiredByDate,
    offramp: state.gas.offramp,
    selectedAddress: selectedAddress(state), 
    premiseNumber: state.gas.parcel && state.gas.parcel.data.premiseInfo && state.gas.parcel.data.premiseInfo.premiseNumber,
    productName: state.gas.pageName,
    buildingType : state.form.buildingType,
    isNewBuilding :  state.form.buildingCondition == "New",
    isSingleMeter : (state.form.buildingType == "2" && state.form.duplexMeterCount == "2"),
    isSingleMeterLocation :  (state.form.duplexSecondMeterLocation && state.form.duplexSecondMeterLocation == "2"),
    meterLocation :  state.form.OfframpMeterLocation,
    squareFootage:  state.form.OfframpSquareFootage,
    gasAppliances: state.form.OfframpGasAppliances,
    heatingSystem:  state.form.OfframpHeatingSystem,
    ageOfProperty:  state.form.OfframpAgeOfProperty,
    otherInfo:  state.form.OfframpOtherInfo,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error })
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(OffRamp);